/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import globals from '../../../globals/communityGlobals';

export const contextDefaultProps = {
  forceReload: false,
  mappingType: 0,
  requestStatus: 0,
  fromDate: globals.now.subtract(1, 'd'),
  toDate: globals.now.add(1, 'd'),
  orgUnitId: null,
  visitId: '',
  isDataLoading: false,
  isTableDataLoading: false,
  hideActionButtons: false,

  currentPage: 1,
  pageSize: 15,
  openSidePanel: false,
  sortColumn: 'CreatedDate',
  sortDirection: 'desc',
  selectedAppointment: null,
  assignmentId: null,
  patientInfo: null,
  showActionConfirmation: false,
  requestIds: [],
  actionName: '',
  message: null,
  showSnackbar: false,
  selectedAllForSending: false,
};

const ExternalProviderContext = React.createContext([{}, () => {}]);

const ExternalProvider = props => {
  contextDefaultProps.auth = useSelector(state => state.global.auth);
  contextDefaultProps.orgUnitId = useSelector(store => store.areas.dailyPlanning.filters.selectedTeam);
  const [state, setState] = useState({ ...contextDefaultProps });
  return (
    <ExternalProviderContext.Provider value={[state, setState]}>{props.children}</ExternalProviderContext.Provider>
  );
};

export { ExternalProviderContext, ExternalProvider };
